import { render } from "./GenericContentComponentUsage.vue?vue&type=template&id=189efd00&scoped=true"
import script from "./GenericContentComponentUsage.vue?vue&type=script&lang=js"
export * from "./GenericContentComponentUsage.vue?vue&type=script&lang=js"

import "./GenericContentComponentUsage.vue?vue&type=style&index=0&id=189efd00&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189efd00"]])

export default __exports__